import script from "./ApprovalProcessDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalProcessDialog.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalProcessDialog.vue?vue&type=style&index=0&id=66f1c82f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f1c82f"]])

export default __exports__